// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"3158776cec38ac26f03b","691":"2fcfdab5464aa7d4d2c1"}[chunkId] + ".js";
};